import { Outlet } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import Sidebar from "./Sidebar";
import AiAssistantWidget from "@/components/AiAssistantWidget";
import { Menu } from "lucide-react";

export default function DashboardLayout() {
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const cachedUser = localStorage.getItem('user');
    if (cachedUser) {
      try { setUser(JSON.parse(cachedUser)); } catch { /* invalid cached data */ }
    }
  }, []);

  const outletContext = useMemo(() => ({ user }), [user]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="dashboard-layout">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <Sidebar user={user} mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-slate-200 flex items-center px-4 z-30">
        <button onClick={() => setSidebarOpen(true)} className="p-2 -ml-2 rounded-lg hover:bg-slate-100" data-testid="mobile-menu-btn">
          <Menu className="w-5 h-5 text-slate-700" />
        </button>
        <div className="flex items-center gap-2 ml-3">
          <div className="w-7 h-7 bg-red-600 rounded-md flex items-center justify-center">
            <span className="text-white font-barlow font-bold text-sm">U</span>
          </div>
          <span className="text-sm font-barlow font-bold text-slate-900">UcarFlow</span>
        </div>
      </div>

      {/* Main content */}
      <main className="lg:ml-[260px] min-h-screen pt-14 lg:pt-0">
        <div className="max-w-[1920px] mx-auto p-4 lg:p-6 xl:p-8">
          <Outlet context={outletContext} />
        </div>
      </main>
      <AiAssistantWidget />
    </div>
  );
}
